// client/src/components/ProtocolManager.js
import React, { useState } from "react";
import ProtocolList from "./ProtocolList";
import ProtocolForm from "./ProtocolForm";
import './protocols.css'

function ProtocolManager() {
  const [currentView, setCurrentView] = useState("list");
  const [selectedProtocol, setSelectedProtocol] = useState(null);

  const handleAddNew = () => {
    setSelectedProtocol(null);
    setCurrentView("form");
  };

  const handleEdit = (protocol) => {
    setSelectedProtocol(protocol);
    setCurrentView("form");
  };

  const handleSave = () => {
    setCurrentView("list");
  };

  const handleCancel = () => {
    setCurrentView("list");
  };

  return (
    <div className="protocol-manager app-container">
      {currentView === "list" && (
        <ProtocolList onEdit={handleEdit} onAddNew={handleAddNew} />
      )}

      {currentView === "form" && (
        <ProtocolForm
          protocol={selectedProtocol}
          onSave={handleSave}
          onCancel={handleCancel}
        />
      )}
    </div>
  );
}

export default ProtocolManager;